export default {"src":"/_next/static/media/hero.7d09b6c7.svg","height":992,"width":992,"blurWidth":0,"blurHeight":0};